import axios from "axios";

switch (process.env.REACT_APP_BUILD_MODE) {
  case "development":
    axios.defaults.baseURL = "https://dev-api.go-evio.com";
    break;
  case "qa":
    axios.defaults.baseURL = "https://pre-api.go-evio.com";
    break;
  case "production":
    axios.defaults.baseURL = "https://api.go-evio.com";
    break;
  case "pre-production":
    axios.defaults.baseURL = "https://pre-api.go-evio.com";
    break;
  default:
    axios.defaults.baseURL = "https://dev-api.go-evio.com";
}

axios.defaults.headers.common["apikey"] = process.env.REACT_APP_EVIOAPI;
